import toast from "react-hot-toast";
import { log, supabase } from ".";

export const getUsuariosByPaisAndRol = async ({ pais, roles }) => {
  try {
    const data = await supabase.select("usuarios", {
      where: {
        pais: pais,
        rol: { in: roles },
      },
      orderBy: { nombre: "asc" },
    });

    if (data?.length === 0) {
      toast.error("No se encontraron usuarios con esos criterios");
      throw new Error("No data found");
    }

    return data;
  } catch (error) {
    log.error("getUsuariosByPaisAndRol", error);
    throw error;
  }
};
